import ENDPOINT from "@/config/endpoint";
import request from "@/utils/request";

async function getUserInfo(params) {
  return await request({
    url: ENDPOINT.USER_INFO,
    method: "get",
    params
  });
}

export default {
  getUserInfo,
};
